import { LoginSection } from "./sections/login.section";

export const Login = () => <LoginSection />;
